module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "not"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("Note on Translations")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A comparative study like this one relies on the efforts of many different translators, who sometimes use different systems of rendering the original language into English. I have used the best translations I could find for each quoted text, and altered the spellings of certain names and titles to conform to my understanding of current transliteration standards."), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-737c9ae5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/not.vue
// module id = 78
// module chunks = 0